import { render, staticRenderFns } from "./basicPost.vue?vue&type=template&id=92857472&scoped=true"
import script from "./basicPost.vue?vue&type=script&lang=js"
export * from "./basicPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92857472",
  null
  
)

export default component.exports